import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Layout from './Layout';
// import '../assets/css/style.css';
// import '../assets/scss/style.scss';
// import '../assets/css/admin.css';
import { dbPost } from '../apis/commonApi';

import { setStore } from '../apis/axiosInterceptor';
import {
  GlobalProvider,
  LoadingContext,
  ModalProvider,
  BreadcrumbProvider,
  GlobalContext,
} from './contexts';

import HeaderNew from './HeaderNew';
import Footer from './Footer';
import ModalArea from './modalComponents/ModalArea';
import LoadingAnimation from './loadingComponents/LoadingAnimation';

const Root = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const loadingStore = {
    setLoading,
  };

  useEffect(() => {
    setStore(loadingStore);
  }, [loadingStore]);

  return (
    <div id="wrap" className="wrapper">
      <ModalProvider>
        <GlobalProvider>
          <LoadingContext.Provider value={loadingStore}>
              <BreadcrumbProvider>
                {loading && <LoadingAnimation />}
                <ModalArea />
                <HeaderNew />
                <PageContent location={location} />
                <Footer />
              </BreadcrumbProvider>
          </LoadingContext.Provider>
        </GlobalProvider>
      </ModalProvider>
    </div>
  );
};

const PageContent = () => {
  const location = useLocation();
  const { store } = React.useContext(GlobalContext);

  useEffect(() => {
    const logPageVisit = async () => {
      if (!store?.entSn) return;

      const logData = {
        urlPath: location.pathname,
        loginUserSn: store.entSn || '',
        userType: store.userType || '',
      };

      try {
        const url = '/common/log.do';
        await dbPost(url, logData);
      } catch (error) {
      }
    };

    logPageVisit();
  }, [location, store]);

  const isDashboard = location.pathname === '/'; 

  return isDashboard ? <Outlet /> : <Layout><Outlet /></Layout>;
};

export default Root;
